import { Injectable, ViewChild } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor, HttpErrorResponse, HttpClient
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    refresh = false;

    constructor(
        private router: Router    
    ) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const req = request.clone();
        return next.handle(req).pipe(catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
                localStorage.clear();
                this.router.navigateByUrl('/');
                window.location.reload();
            }
            return throwError(() => err);
        }));
    }
}